import {
  accessLogRequestConfig,
  buildAccessLogPayload,
  getAccessLogsUrl
} from '~/helpers/access-logs'

export default ({
  route,
  $axios,
  $config,
  $cookies
}) => {
  if (process.server) {
    return
  }

  try {
    const accessLogsUrl = getAccessLogsUrl($config.apiBaseURL)
    const payload = buildAccessLogPayload({
      route,
      $cookies
    })

    $axios.post(accessLogsUrl, payload, accessLogRequestConfig()).catch(() => {
    })
  } catch (e) {
    console.log('could not post access logs', e)
  }
}
